/**
   * @license
   * author: Shippo Engineering <engineering@goshippo.com>
   * shippo-utilities.js v3.0.0
   * Released under the UNLICENSED license.
   */
import{jsx as r}from"react/jsx-runtime";import{init as t,identify as e,isInitialized as i,event as o,setUserVars as s}from"@fullstory/browser";import{createContext as n,useEffect as l,useMemo as c}from"react";const m=n(void 0),a=({children:n,fullStoryOpts:a})=>{l((()=>{a&&t(a)}),[]);const d=c((()=>({identify:e,isInitialized:i,event:o,setUserVars:s})),[]);return r(m.Provider,Object.assign({value:d},{children:n}))};export{m as FullStoryContext,a as FullStoryProvider};
//# sourceMappingURL=FullStoryProvider.js.map
